<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2021 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 East 60th Street, Chicago, IL 60637.</p>
<p class="crt">Published 2021</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">30 29 28 27 26 25 24 23 22 21    1 2 3 4 5</p>
<p class="crtf"><span class="sm">ISBN</span>-13: 978-0-226-77614-9 (cloth)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-77628-6 (paper)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-77631-6 (e-book)</p>
<p class="crt"><span class="sm">DOI</span>: <a class="url" href="https://doi.org/10.7208/chicago/9780226776316.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226776316.001.0001</a></p>
<p class="crtf">The University of Chicago Press gratefully acknowledges the generous support of the Office of Research and the College of Letters and Science at the University of California, Davis, toward the publication of this book.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Menely, Tobias, author.</p>
<p class="cip">Title: Climate and the making of worlds : toward a geohistorical poetics / Tobias Menely.</p>
<p class="cip">Other titles: Toward a geohistorical poetics</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2021. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: <span class="sm">LCCN</span> 2021004016 | <span class="sm">ISBN</span> 9780226776149 (cloth) | <span class="sm">ISBN</span> 9780226776286 (paperback) | <span class="sm">ISBN</span> 9780226776316 (ebook)</p>
<p class="cip">Subjects: <span class="sm">LCSH</span>: English poetry—18th century—History and criticism. | English poetry—17th century—History and criticism. | Ecology in literature. | Seasons in literature. | Climatic changes in literature. | Human ecology in literature. | Climate and civilization—Great Britain.</p>
<p class="cip">Classification: <span class="sm">LCC</span> <span class="sm">PR</span>551 .m46 2021 | ddc 821/.50936—dc<i>23</i></p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2021004016" target="_blank">https://lccn.loc.gov/2021004016</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of <span class="sm">ANSI/NISO</span> <span class="sm">Z</span>39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-menely-0004.vue?5c11f172